import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import React from 'react';

import CustomTooltip from './CustomTooltip';
import {
  FIELDS_COMPUTED_FORMULA,
  FIELDS_IS_COMPUTED,
} from '../../../../constants/entity-designer.constants';
import {
  getIsCheckboxDisabled,
  getIsCheckboxVisible,
} from '../../../../utils/entity-designer.utils';

const useStyles = makeStyles({
  booleanCell: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const getIsComputedValueError = ({ key, errors = [] }) => {
  if (key !== FIELDS_IS_COMPUTED) {
    return;
  }

  const computedFormulaError = errors.find(
    (error) => error?.controlInfo?.prop === FIELDS_COMPUTED_FORMULA
  );

  return !!computedFormulaError;
};

const EditableCheckboxCell = ({ row, column: { accessor: key } }) => {
  const classes = useStyles();
  const isVisible = getIsCheckboxVisible({ row, key });
  const isDisabled = getIsCheckboxDisabled({ row, key });

  return (
    <>
      {isVisible && (
        <div className={classes.booleanCell}>
          <CustomTooltip prop={key}>
            <Checkbox
              checked={row[key]}
              disabled={isDisabled}
              onChange={({ target: { checked } }) =>
                row.editRow({
                  rowId: row.rowId,
                  key,
                  value: checked,
                  error: getIsComputedValueError({ key, errors: row.errors }),
                })
              }
              aria-label={row[key]}
            />
          </CustomTooltip>
        </div>
      )}
    </>
  );
};

export default EditableCheckboxCell;
